import axios from '../../../axios';
import { JobSiteSearch } from '../types/JobSiteSearch';

export const searchJobSiteSearchBuilder = async (query: JobSiteSearch) =>
  await axios.post('/candidatesearch/api/job-site/search', query);
export const getJobSiteLocations = (searchKey: string) =>
  axios.get(`/candidatesearch/api/job-site/location?query=${searchKey}`);
